import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from 'libs/portal/src/layout/layout.component';
import { AuthGuardService } from 'libs/portal/src/services/auth-guard/auth-guard.service';
import { UserRightsAuthGuardService } from 'libs/portal/src/services/user-rights-auth-guard.service';
import { GoToMenuComponent } from 'libs/portal/src/modules/tools/navbar/components/go-to-menu/go-to-menu.component';
import { HomePageComponent } from './pages/home-page/home-page.component';

const routes: Routes = [
  {
    path: 'SystemAdmin',
    canActivate: [AuthGuardService],
    component: LayoutComponent,
    data: { breadcrumb: 'System Administration' },
    loadChildren: () => import('./pages/alert-configuration/alert-configuration.module').then((m) => m.AlertConfigurationModule),
  },
  {
    path: 'ChangeSession',
    canActivate: [AuthGuardService],
    component: LayoutComponent,
    data: { breadcrumb: 'Change Session' },
    loadChildren: () => import('./pages/change-session/change-session.module').then((m) => m.ChangeSessionPageModule),
  },
  {
    path: 'Profile',
    canActivate: [AuthGuardService],
    component: LayoutComponent,
    data: { breadcrumb: 'Profile' },
    loadChildren: () => import('./pages/profile-page/profile-page.module').then((m) => m.ProfilePageModule),
  },
  {
    path: 'ChangePassword',
    canActivate: [AuthGuardService],
    component: LayoutComponent,
    data: { breadcrumb: 'Change Password' },
    loadChildren: () => import('./pages/change-password-auth/change-password-auth.module').then((m) => m.ChangePasswordAuthModule),
  },
  {
    path: 'UserManagement',
    canActivate: [AuthGuardService, UserRightsAuthGuardService],
    component: LayoutComponent,
    data: { breadcrumb: 'User Management' },
    loadChildren: () => import('./pages/user-management/user-management.module').then((m) => m.UserManagementModule),
  },
  {
    path: '',
    canActivate: [AuthGuardService],
    component: LayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: HomePageComponent,
      },
      {
        path: 'Navigate',
        component: GoToMenuComponent,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuardService],
})
export class HomeRoutingModule { }
